import { trackClientEvent } from 'analytics/analytics'

function generateActionDate(monthNumber: number, year: number): string {
  return `view_${monthNumber}_${year}`
}

/**
 * Client event when a priced offer-page calendar month block (month heading + price grid)
 * becomes visible in the calendar scroll container.
 */
export function trackCalendarMonthImpression(monthNumber: number, year: number): void {
  trackClientEvent({
    subject: 'calendar-month-impression',
    action: generateActionDate(monthNumber, year),
    category: 'offer_funnel',
    type: 'nonInteraction',
  })
}
